(function () {
	angular
		.module('trackeye')
		.factory('Echotag', _EchotagFactory);

	_EchotagFactory.$inject = [];

	function _EchotagFactory() {

		function Echotag() {
			this.tag_id = undefined;
			this.tag_description = undefined;
			this.tag_model = undefined;
			this.prefetch = false;

			this.new = true;
		}

		Echotag.prototype.getId = function () {
			return this.tag_id;
		};

		Echotag.prototype.getGuid = function () {
			return this.guid;
		};

		Echotag.prototype.getDescription = function () {
			return this.tag_description;
		};

		Echotag.prototype.getModel = function () {
			return this.tag_model;
		};

		Echotag.prototype.setGuid = function (guid) {
			this.guid = guid;

			return this;
		};

		Echotag.prototype.isPrefetched = function () {
			return this.prefetch;
		};

		Echotag.prototype.isNew = function (value) {
			if (value === undefined)
				return this.new;

			return this.new = value;
		};

		Echotag.prototype.toJSON = function () {
			return {
				tag_id: this.getId(),
				tag_model: this.getModel().toString().toUpperCase(),
				tag_description: this.getDescription()
			};
		};

		Echotag.prototype.populate = function (data, isNew) {
			this.new = isNew;

			for (var key in data) {
				if (data.hasOwnProperty(key)) {
					this[key] = data[key];
				}
			}

			return this;
		};

		return Echotag;
	}
})();